/** Official AP MSME portal — navbar logo links here from all dashboard pages */
export const APMSME_PORTAL_URL = 'https://apmsmeone.ap.gov.in/';
